<div class="flex flex-column gap-2">
  @if (afficherLabel) {
    <label [for]="inputId">{{ titreLabel }}</label>
  }

  @if (editionAuClic && !enEdition) {
    <span
      class="champConsultation inline-edit__display"
      [class.cursor-pointer]="!lectureSeule"
      [class.inline-edit__display--editable]="!lectureSeule"
      (click)="commencerEdition()"
      tabindex="0"
      (keydown.enter)="commencerEdition()">
      {{ texteAffichage }}
      @if (releveLie) {
        <i class="pi pi-link ml-2 text-color-secondary" [pTooltip]="texteReleveLie"></i>
      }
    </span>
  } @else {
    <div class="flex gap-2 align-items-center">
      <div class="flex-grow-1 min-w-0">
        @if (modeSelection) {
          <p-dropdown
            [id]="inputId"
            [options]="releves"
            [(ngModel)]="selectionReleveId"
            (onChange)="surSelectionReleve($event.value)"
            (onHide)="surFermetureListe()"
            optionLabel="label"
            optionValue="value"
            placeholder="Sélectionner un relevé…"
            [filter]="true"
            filterBy="label"
            appendTo="body"
            [showClear]="true"
            [loading]="chargement"
            [disabled]="lectureSeule"
            styleClass="w-full" />
        } @else if (type === 'heure') {
          <p-inputNumber
            [inputId]="inputId"
            [(ngModel)]="valeurInterne"
            (ngModelChange)="surChangementValeur($event)"
            (onBlur)="confirmerValeur()"
            [placeholder]="placeholderTexte"
            [disabled]="lectureSeule"
            suffix=" h"
            [min]="0"
            [useGrouping]="false"
            styleClass="w-full" />
        } @else {
          <p-inputNumber
            [inputId]="inputId"
            [(ngModel)]="valeurInterne"
            (ngModelChange)="surChangementValeur($event)"
            (onBlur)="confirmerValeur()"
            [placeholder]="placeholderTexte"
            [disabled]="lectureSeule"
            suffix=" km"
            [min]="0"
            [useGrouping]="false"
            styleClass="w-full" />
        }
      </div>

      @if (!lectureSeule && peutBasculer) {
        <p-button
          [icon]="modeSelection ? 'pi pi-pencil' : 'pi pi-link'"
          severity="secondary"
          [outlined]="true"
          styleClass="flex-none"
          [pTooltip]="modeSelection ? 'Saisir une nouvelle valeur' : 'Sélectionner un relevé existant'"
          (mousedown)="retenirEdition($event)"
          (onClick)="basculerMode()" />
      }
    </div>

  }
</div>
